import { Box, Flex } from "@chakra-ui/react";
import React from "react";

import { Spinner } from "../../../components";

const LoadingMessage: React.FC<{ text?: string }> = ({
  text = "Preparing your interview...",
}) => (
  <Flex position="relative" top="-3rem" flexDirection="column" align="center">
    <Spinner width="96px" height="96px" />
    <Box
      color="primary"
      fontWeight="bold"
      fontSize="24px"
      mt="12"
      px="2"
      textAlign="center"
    >
      {text}
    </Box>
  </Flex>
);
export default LoadingMessage;
